<!-- [class.sidebar--open]="isSidebarOpen" -->
<button class="nav-tgl" type="button" aria-label="toggle menu" (click)="toggleMenuResponsive()"
  [ngClass]="showMenu ? 'close-menu' : ''">
  <span aria-hidden="true"></span>
</button>
<div class="side-menu" [ngClass]="[showMenu ? 'open-menu' : '', collapseMenu ? 'small-menu' : '']">
  <div class="logo-widget">
    <button class="collapse-tgl" type="button" aria-label="toggle menu" (click)="toggleMenuDesktop()"
      [ngClass]="collapseMenu ? '' : 'close-menu'">
      <span aria-hidden="true"></span>
    </button>
    <sp-logo *ngIf="!collapseMenu" class="logo logo-primary" type="primary" theme="dark"></sp-logo>
  </div>
  <div>
    <div class="menu-scroll">
      <sp-menu-v2 (linkClicked)="menuLinkClicked($event)" [groups]="menuLinks"></sp-menu-v2>
    </div>
  </div>
</div>